export default {
  title: 'Receive automatic monthly flyers',
  status: {
    enabled: 'Enabled',
    disabled: 'Disabled',
  },
  opt_out: {
    on_hint: 'Your FoodAmigos plan includes 500 free flyers per month. Turn this off to stop receiving them.',
    off_hint: 'Automatic flyers are paused. Turn on to resume from next month’s run.',
    confirm_off: {
      title: 'Turn off automatic flyers?',
      body: 'Turning this off means {{location}} will not receive automatic flyers from next month’s run onward. Existing orders are unaffected.',
      confirm: 'Turn off',
      cancel: 'Keep on',
    },
  },
  approved_design: {
    label: 'Approved design for monthly flyers',
    auto_option: 'Automatic (most recently ordered)',
    flyer_slot: 'Flyer {{slot}}',
    custom: 'Custom',
    untitled: 'Untitled',
    invalid_warning:
      'The saved design is no longer available. The most recently ordered flyer will be used until you pick a new one.',
  },
  toasts: {
    failed_to_load: 'Failed to load automatic flyer settings',
    failed_to_save: 'Failed to save changes',
    saved: 'Changes saved',
  },
};
